import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { HYGRAPH_CONTENT_STAGES_LIST, HYGRAPH_CONTENT_STAGES } from "@shared/consts/hygraph-preview";
import { AuthenticationService } from '@app/auth';
import { isUserAllowedToPreviewHygraph } from '@app/@shared/utils/hygraph-preview-role-selector';

@Component({
  selector: 'app-content-stage-dropdown',
  templateUrl: './content-stage-dropdown.component.html',
  styleUrl: './content-stage-dropdown.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ContentStageDropdownComponent implements OnInit, OnChanges {
  @Output() stageChange = new EventEmitter<string>();
  @Input() selectedStage: string;

  stages = HYGRAPH_CONTENT_STAGES_LIST;
  hasStagingAccess = false;
  currentValue = this.stages[0].value;
  showSelect = true;

  constructor(private readonly authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.authenticationService.me().subscribe((user) => {
      this.hasStagingAccess = isUserAllowedToPreviewHygraph(user);

      if (this.selectedStage) {
        this.currentValue = this.selectedStage;
      } else {
        this.currentValue = HYGRAPH_CONTENT_STAGES.PUBLISHED;
      }

      this.stageChange.emit(this.currentValue);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedStage']) {
      const newValue = changes['selectedStage'].currentValue;

      if (newValue === '') {
        return;
      }

      if (newValue && newValue !== this.currentValue) {
        this.showSelect = false;
        this.currentValue = newValue;

        setTimeout(() => {
          this.showSelect = true;
        }, 0);
      } else if (newValue === this.currentValue) {
        this.showSelect = false;
        setTimeout(() => {
          this.showSelect = true;
        }, 0);
      }
    }
  }

  public onStageChange(stage: string): void {
    this.stageChange.emit(stage);
  }
}
